import React from "react";
import "./featuredSnippet.css";
import { findSnippet } from "../../data/snippets";

interface FeaturedSnippetProps {
  query: string;
}

const FeaturedSnippetBox = ({ query }: FeaturedSnippetProps) => {
  const snippet = findSnippet(query);
  if (!snippet) return null;

  return (
    <div className="featured-snippet">
      <h3 className="fs-title">{snippet.title}</h3>
      <p className="fs-content">{snippet.content}</p>
      {snippet.type === "list" && snippet.listItems && (
        <ul className="fs-list">
          {snippet.listItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FeaturedSnippetBox;
